import set from "@rill/set";
import CheckinSummary from "./CheckinSummary";
import moment from "moment";
import JWPlayerVideoModal from "../../../../parts/modals/jwplayer-video";
import { frequencyLimit } from "../../../../utils/questionnaire";
import ActivityDrawer from "../../../../parts/activity-drawer/ActivityDrawer";

const CheckInSummaryController = (app) => {
  app.get(
    "/check-in-summary",
    set("heading", "Check-in Summary"),
    async ({ req, res, locals, load }) => {
      const { query } = req;
      const {
        athlete,
        checkInDate,
        checkInFrequency,
        athleteSwitch,
        organizationCoach,
      } = query;
      const modal = query.modal || {};

      const isAllowToViewAllOrganizationsAthletes =
        locals.organizationRoleName &&
        (locals.organizationRoleName === "Owner" ||
          locals.organizationRoleName === "Admin");

      if (
        locals.activeUser.organizationId &&
        isAllowToViewAllOrganizationsAthletes &&
        !locals.allAthletesFromOrganization
      ) {
        await load("allAthletesFromOrganization");
      }

      // Basically the start of the year 2023 as we don't need information before then
      const dailyStart = moment("2023-06-01")
        .startOf("year")
        .format("YYYY-MM-DD");

      await load("dailyStats", {
        proxyAthlete: athlete,
        start: dailyStart,
      });

      let selectedAnswer = null;

      if (checkInDate && !athleteSwitch) {
        // Minimum of 7 days, this is for the new loom feature that doesn't have access to the frequency
        const dayLimit = frequencyLimit[checkInFrequency] || 7;

        const end = moment(checkInDate).format("YYYY-MM-DD");
        const start = moment(end)
          .subtract(dayLimit, "days")
          .format("YYYY-MM-DD");

        selectedAnswer = locals.dailyStats.find(
          (stat) =>
            stat.utcDate === Number(moment(checkInDate).format("YYYYMMDD")) &&
            !!stat.questionnaire
        );

        if (selectedAnswer) {
          await Promise.all([
            load("nutritionPlans", {
              proxyAthlete: athlete,
            }),
            load("activeExercises", {
              proxyAthlete: athlete,
              reqSource: "calendar",
              start,
              end,
            }),
            load("dayPersonalRecords", {
              start: moment(start).format("YYYYMMDD"),
              end: moment(end).endOf("day").format("YYYYMMDD"),
              proxyAthlete: athlete,
              isCheckIn: true,
            }),
            load("videoListMetrics", {
              page: 1,
              limit: 50, // 50 videos, might change in the future
              sort: -1,
              proxyAthlete: athlete,
              from: moment.utc(start, "YYYY-MM-DD").toDate(),
              to: moment.utc(end, "YYYY-MM-DD").toDate(),
            }),
            load("videoRecord", checkInDate, athlete, "check-in"),
            load("workoutNote", checkInDate, athlete, "check-in"),
            load(
              "workoutCoachNote",
              checkInDate,
              athlete,
              organizationCoach || locals.activeUser._id,
              "check-in"
            ),
          ]);
        }
      }

      locals.modal = {
        "watch-video-list": (
          <JWPlayerVideoModal
            mediaId={query.mediaId}
            originalId={query.originalId}
            athleteId={query.mediaAthleteId || query.athlete}
            exerciseToEdit={query.exerciseToEdit}
            reviewedByTheCoach={query.reviewedByTheCoach}
            setIndex={query.setIndex}
            videoIndex={query.videoIndex}
          />
        ),
        "activity-feed": <ActivityDrawer />,
      }[modal.type];

      res.body = (
        <CheckinSummary locals={locals} selectedAnswer={selectedAnswer} />
      );
    }
  );
};

export default CheckInSummaryController;
